import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    BooleanInput,
    SelectInput,
    SaveButton,
    Toolbar,
    TextField,
    ReferenceField,
    FunctionField,
    Labeled,
    DateField,
    Button,
    TopToolbar,
} from 'react-admin';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { required } from 'react-admin';
import { Grid, Box, Typography, Stack } from '@mui/material';

const statusChoices = [
    { id: 0, name: 'Aktiivinen' },
    { id: 1, name: 'Poistettu' },
    { id: 2, name: 'Luonnos' },
];

const EditActions = () => (
    <TopToolbar>
        <Button label="Hallinta" component={Link} to="/hallinta?tab=2">
            <ArrowBackIcon />
        </Button>
    </TopToolbar>
);

const EditToolbar = () => (
    <Toolbar>
        <SaveButton />
    </Toolbar>
);

const MaterialstorageEdit = () => (
    <Edit redirect={false} mutationMode="optimistic" actions={<EditActions />}>
        <SimpleForm toolbar={<EditToolbar />}>
            <Grid container width={{ xs: '100%' }} spacing={2}>
                <Grid size={{ xs: 12, md: 8 }}>
                    <Labeled label="GUID">
                        <TextField source="guid" />
                    </Labeled>
                </Grid>
                <Grid size={{ xs: 12, md: 8 }}>
                    <TextInput
                        source="name"
                        validate={[required()]}
                        fullWidth
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 8 }}>
                    <TextInput
                        source="path"
                        validate={[required()]}
                        fullWidth
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 8 }}>
                    <SelectInput
                        source="status"
                        choices={statusChoices}
                        fullWidth
                    />
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>
                        Asetukset
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 8 }}>
                    <BooleanInput source="public.sso" />
                </Grid>
                <Grid size={{ xs: 12, md: 8 }}>
                    <BooleanInput source="public.redirtoken" />
                </Grid>
                <Grid size={{ xs: 12, md: 8 }}>
                    <BooleanInput
                        source="public.prewarm"
                        helperText="resources.materialstorage.fields.public.prewarm_help"
                    />
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>
                        Tekijätiedot
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Stack direction="row" spacing={4}>
                        <Box>
                            <Labeled label="resources.materialstorage.fields.author.creator">
                                <>
                                    <ReferenceField
                                        reference="user"
                                        source="author.creator"
                                    >
                                        <FunctionField
                                            render={record =>
                                                `${record.public.firstname} ${record.public.lastname}`
                                            }
                                        />
                                    </ReferenceField>
                                    <DateField
                                        source="author.created"
                                        showTime
                                        locales="fi-FI"
                                    />
                                </>
                            </Labeled>
                        </Box>
                        <Box>
                            <Labeled label="resources.materialstorage.fields.author.modifier">
                                <>
                                    <ReferenceField
                                        reference="user"
                                        source="author.modifier"
                                    >
                                        <FunctionField
                                            render={record =>
                                                `${record.public.firstname} ${record.public.lastname}`
                                            }
                                        />
                                    </ReferenceField>
                                    <DateField
                                        source="author.modified"
                                        showTime
                                        locales="fi-FI"
                                    />
                                </>
                            </Labeled>
                        </Box>
                    </Stack>
                </Grid>
            </Grid>
        </SimpleForm>
    </Edit>
);

export default MaterialstorageEdit;
